export default "__VITE_ASSET__WKplRf93__"